import {IS_LOGIN}  from './../actions/types';

const INITIAL_STATE = {
    isAdminLogin: localStorage.getItem('auth_token') ? (localStorage.getItem('auth_token').length ? true: false): false ,
};

export default function (state = INITIAL_STATE , action)
{
    switch(action.type){
        case IS_LOGIN : 
        return {
            ...state,
            isAdminLogin: action.payload,
        }

        default :
        return{
            ...state
        };
    }
}